import _, { camelCase, uniqueId } from 'lodash';

export const handleQuestionsInitialAdjustments = (
	questionnaire,
	operation,
	setIdProductPlan,
	isInAnalysis,
	setFieldValue,
	sharedCCG,
	permissions,
	token
) => {
	return questionnaire.map(question => {
		if (question.idQuestion === 1726) {
			question.disabled = false;

			let isAutomaticCCG = false;
			if (token && permissions && !permissions?.FORMALIZE_CREDIT_ANALYSIS && !permissions?.ANALYZE_CREDIT_ANALYSIS_SAVE) {
				const { idPersonRoot, applicationPersonRoot } = token.login_response.ret_value;
				if (idPersonRoot !== applicationPersonRoot) {
					isAutomaticCCG = true
				}
			}

			const niPartners = questionnaire
				.filter(qst => qst.idQuestion === 1654)
				.map(qst => (qst.answer.length > 11 ? "PJ" : "PF"));

			let answerOption;
			const containsPJ = niPartners.includes("PJ");
			const containsPF = niPartners.includes("PF");

			if (question?.idAnswerOption) {
				answerOption = question.answerOptions.find(v => v.idAnswerOption === question.idAnswerOption);
			} else if (containsPJ && !containsPF) {
				answerOption = question.answerOptions.find(v => v.idAnswerOption === (isAutomaticCCG ? 7534 : 7342));
			} else if (!containsPJ && containsPF) {
				answerOption = question.answerOptions.find(v => v.idAnswerOption === (isAutomaticCCG ? 7533 : 7341));
			} else if (containsPJ && containsPF) {
				answerOption = question.answerOptions.find(v => v.idAnswerOption === (isAutomaticCCG ? 7535 : 7343));
			} else if (question.idAnswerOption === null) {
				answerOption = question.answerOptions.find(v => v.idAnswerOption === (isAutomaticCCG ? 7533 : 7341));
			}

			question.answer = answerOption.dsAnswerOption;
			question.answerJson = answerOption.dsAnswerOption;
			question.idAnswerOption = answerOption.idAnswerOption;

			const questionAnswers = {
				dsAnswerOption: answerOption.dsAnswerOption,
				idAnswerOption: answerOption.idAnswerOption,
				resultValue: answerOption.behaviorObject?.resultValue || null
			};

			setFieldValue && setFieldValue(question.key, questionAnswers);
			setIdProductPlan && setIdProductPlan(answerOption.behaviorObject?.resultProductPlan);
		}

		if (question.idQuestion === 1813) {
			question.behaviorObject.isRequired = false;
		}

		if (question.idQuestion === 2007) {
			question.behaviorObject.sectionName = "CCG_DATA";

			if (question.idAnswerOption) {
				sharedCCG.current = question.idAnswerOption === 7684;
			}
		}

		if (question.idQuestion === 2008) {
			const isSPE = questionnaire.find(qst => qst.idQuestion === 1723)?.idAnswerOption === 7336;
			const useCCG = questionnaire.find(qst => qst.idQuestion === 2007)?.idAnswerOption === 7684;
			question.behaviorObject.sectionName = "CCG_DATA";
			const { person: borrowerPerson } = operation.operationPersonRoles?.find(pRoles => pRoles.idDomain === 497);

			if (!question.answer) {

				const answer = JSON.stringify({
					value: borrowerPerson.legalPersonId,
					id:borrowerPerson.idPerson,
				});

				question.answer = answer;
				question.answerJson = answer;
			}

			question.behaviorObject.isReadOnly = !isSPE || !useCCG;
			question.disabled = !isSPE || !useCCG;
			question.behaviorObject.isRequired = true;
			question.visibleQuestion = true;
		}

		if ([1634, 1635, 1807].includes(question.idQuestion)) {
			const disabled = [1634, 1635].includes(question.idQuestion);
			question.disabled = disabled;
			question.behaviorObject.isReadOnly = disabled;
			question.behaviorObject.sectionName = 'LEGAL_REPRESENTATIVE';
		}

		return question;
	});
}

export const groupConvertToSimpleData = (mainIdQuestion, questionnaire, operation, isBound) => {
	const groupQuestions = [];

	const mainQuestions = questionnaire.filter(question => question.idQuestion === mainIdQuestion);
	for (const mainQuestion of mainQuestions) {
		const questions = mainQuestion.childrenQuestions;

		if (mainIdQuestion === 1654) {
			const documentId = mainQuestion.answer || '';

			const name = questions.find(qst => qst.idQuestion === 1655)?.answer || '';

			const email = questions.find(qst => qst.idQuestion === 1780)?.answer || '';

			const selectedPartner = questions.find(qst => qst.idQuestion === 2040)?.idAnswerOption;

			const partners = {
				selected: selectedPartner === 7695 || !selectedPartner ? true : false,
				documentId,
				name,
				email,
				entryDate: ""
			};

			groupQuestions.push(partners);
		}
	}

	return groupQuestions;
}

const getQuestionnairePartnerEmailByDocumentId = (questionnaire, documentId) => {
	const partnersAnswers = questionnaire.filter(
		qst => qst.idQuestion === 1654 && qst.answer === documentId
	);
	const email = partnersAnswers.map(row =>
		row.childrenQuestions.find(qst => qst.idQuestion === 1780)
	)[0]?.answer || '';
	return email;
}

export const getSelectedPartners = (questionnaire, partners) => {
	return partners.filter(ptnr => ptnr.selected)?.map(ps => (
		{
			idPerson: parseInt(ps.documentId),
			name: ps.name,
			email: getQuestionnairePartnerEmailByDocumentId(questionnaire, ps.documentId),
		}
	)) || [];
}


export const handleClauseQuestionChange = async (questionnaire, setFilteredQuestionnaire, setFieldValue) => {
	let saveFilteredQuestionnaire = false;
	questionnaire = questionnaire.map((question, sectionIndex) => {
		saveFilteredQuestionnaire = true;

		if (!question.key) question.key = `${camelCase(question.dsQuestion)}_${question.idQuestion}_${uniqueId()}`;

		if (question.idQuestion == 1813) {
			const resultAnswer = question.answerOptions.find(q => q.idAnswerOption === 7399);

			question.answer = resultAnswer?.dsAnswerOption;
			question.answerJson = resultAnswer?.dsAnswerOption;
			question.idAnswerOption = resultAnswer?.idAnswerOption;

			const result = {
				dsAnswerOption: resultAnswer?.dsAnswerOption,
				idAnswerOption: resultAnswer?.idAnswerOption,
				resultValue: resultAnswer?.behaviorObject?.resultValue || null
			};
			setFieldValue && setFieldValue(question.key, result)
		}
		return question;
	})

	if (saveFilteredQuestionnaire) setFilteredQuestionnaire(questionnaire);
}

export const handleQuestionChange = async (
	question,
	value,
	questionnaire,
	setFilteredQuestionnaire,
	setFieldValue,
	setChangeLengthClauseInitial,
	handleResetDocumentClauses,
	sharedCCG,
	operation,
	setPartners,
	setOnlyUpdateQuestionnaire
) => {
	let saveFilteredQuestionnaire = false;

	if (question.idQuestion === 1726 && value?.idAnswerOption) {
		setChangeLengthClauseInitial(0)
		handleResetDocumentClauses(question, value)
	};

	if (question.idQuestion === 2015) {
		if (value.idAnswerOption === 7689) {
			setOnlyUpdateQuestionnaire(true);
		} else if (value.idAnswerOption === 7688) {
			setOnlyUpdateQuestionnaire(false);
		}
	}

	if (question.idQuestion === 2007) {
		saveFilteredQuestionnaire = true;
		let isSharedCCG = value?.idAnswerOption === 7684;
		sharedCCG.current = isSharedCCG;
		questionnaire = questionnaire.map(qst => {
			if (qst.idQuestion === 2008) {
				qst.behaviorObject.isReadOnly = !(isSharedCCG);
				qst.disabled = !(isSharedCCG);
				if (!isSharedCCG) {
					const { person: borrowerPerson } = operation.operationPersonRoles.find(pRoles => pRoles.idDomain === 497);

					const answer = JSON.stringify({
						value: borrowerPerson.legalPersonId,
						id: borrowerPerson.idPerson,
					});

					qst.answer = answer;
					qst.answerJson = answer;
					setFieldValue(qst.key, borrowerPerson.legalPersonId);
					return qst;
				}

				qst.answer = "";
				setFieldValue(qst.key, "");
			}
			return qst;
		})
	}

	if (saveFilteredQuestionnaire) setFilteredQuestionnaire(questionnaire);
}